import React, { useState, useEffect, useCallback } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { mobfeeDaily } from 'lib/api/mobfeed';
import { withRouter } from 'react-router-dom';

import { makeRowColumn, getHeadObj, dataConverter } from 'lib/commonLib';
import { paramConverter } from 'modules/common';
import { setPortal } from 'modules/portal';
import { showSuccessSnackbar } from 'modules/snackbar';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import InfoTitleArea from 'components/molecules/MbTable/InfoTitleArea';
import IconAreaWrap from 'components/molecules/MbTable/IconAreaWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import NewTableContainer from 'components/molecules/NewTable';
import FilterCollection from 'components/organisms/FilterCollection';
import { useDispatch, useSelector } from 'react-redux';
import DailyStatisticsGraph from './DailyStatisticsGraph';
import DailyStatisticsGraphPop from './DailyStatisticsGraphPop';
import queryString from 'query-string';
import { useTheme } from '@material-ui/core/styles';

const DailyStatistics = ({ location }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  const initList = {
    mfSupplyTpCode: [
      { label: '전체', value: 'all' },
      { label: '한줄', value: '01' },
      { label: '인앱(포탈)', value: '02' },
    ],
  };

  let initParams = {
    sDate: moment().format('YYYYMM01'),
    eDate: moment().format('YYYYMMDD'),
    mfSupplyTpCode: 'all',
    pltfomTpCode: 'all',
    sort: 'desc',
    order: 'STATS_DTTM',
  };

  //todo [popup-params] 모비피드 - 채널별통계 : channelId, pltfomTpCode, mfSupplyTpCode, sDate, eDate, channel
  //todo [popup-params] 모비피드 - 언론사별통계 : mediaId, pltfomTpCode, mfSupplyTpCode, sDate, eDate
  const convertKeys = [
    'channelId',
    'pltfomTpCode',
    'mfSupplyTpCode',
    'sDate',
    'eDate',
    'isPop',
    'channel',
    'mediaId',
  ];
  const newInitParams = dataConverter(
    queryString.parse(location.search),
    convertKeys
  );
  initParams = {
    ...initParams,
    ...newInitParams,
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const { isPop, channel } = params;

  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    }
  }, [initialization]);

  const handlePortalUrl = useCallback(
    (url) => {
      let newPortal = portal.portal;
      let popIndex = newPortal.length;
      newPortal[popIndex] = {
        url: url,
        cnt: popIndex,
      };
      dispatch(setPortal(newPortal));
    },
    [portal, dispatch]
  );

  const handleOnReset = () => {
    setInitialization(true);
    setParams(initParams);
  };

  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  let customized = {};
  if (parseInt(isPop) === 1 && parseInt(channel) !== 1) {
    customized = {
      STATS_DTTM: {
        makeHead: (headsMap) => {
          return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
        },
        makeBody: (rowObj, headsMap) => {
          const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
          const { isPop } = params;
          const convertKeys = ['mfSupplyTpCode', 'pltfomTpCode'];
          const addParams = dataConverter(params, convertKeys, 'string');
          const showWindowUrl =
            '/report/mobfeed/channel?isPop=1&sDate=' +
            rowObj['STATS_DTTM'] +
            '&eDate=' +
            rowObj['STATS_DTTM'] +
            '&uri=/report/mobfeed/daily' +
            addParams;

          let resultComponent;

          resultComponent = (
            <>
              {rowObj['STATS_DTTM'] !== 'total' && parseInt(isPop) !== 1 ? (
                <>
                  <IconAreaWrap
                    text={makeRowColumn(
                      rowObj['STATS_DTTM'],
                      statsDttm.type,
                      statsDttm.format
                    )}
                    icon={rowObj['STATS_DTTM'] !== 'total' && 'faExternalLink'}
                    toolTipTitle={t('해당 날짜의 채널별 통계')}
                    onClick={(e) => handlePortalUrl(showWindowUrl)}
                  />
                </>
              ) : (
                <>
                  {makeRowColumn(
                    rowObj['STATS_DTTM'],
                    statsDttm.type,
                    statsDttm.format
                  )}
                </>
              )}
            </>
          );

          return resultComponent;
        },
      },
      NEWS_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('수집기사수')}
                  tooltipTitle={t('모비피드 뉴스제공 언론사 수집기사수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'NEWS_CNT');
          return (
            rowObj['STATS_DTTM'] !== 'total' &&
            !rowObj['isChild'] &&
            makeRowColumn(rowObj['NEWS_CNT'], obj.type, obj.format)
          );
        },
      },
      PAGE_VIEW: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('PV')}
                  tooltipTitle={t('페이지뷰')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
      },
      NEWS_GR_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 구좌노출수')}
                  tooltipTitle={t('기사 구좌별 노출수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const valObj = getHeadObj(headsMap, 'NEWS_GR_CNT');
          return (
            <p style={{ color: theme.palette.common.blue }}>
              {makeRowColumn(rowObj['NEWS_GR_CNT'], valObj.type, valObj.format)}
            </p>
          );
        },
      },
      NEWS_TOT_EPRS_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 총노출수')}
                  tooltipTitle={t('모비피드 뉴스제공 언론사 수집 총기사수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const valObj = getHeadObj(headsMap, 'NEWS_TOT_EPRS_CNT');
          return (
            <p style={{ color: theme.palette.common.blue }}>
              {makeRowColumn(
                rowObj['NEWS_TOT_EPRS_CNT'],
                valObj.type,
                valObj.format
              )}
            </p>
          );
        },
      },
      NEWS_CLICK_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 클릭수')}
                  tooltipTitle={t('클릭된 기사수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
      },
      NEWS_CLICK_RATE: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 클릭률')}
                  tooltipTitle={t('(기사클릭수/기사구좌노촐수) * 100')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const valObj = getHeadObj(headsMap, 'NEWS_CLICK_RATE');
          return (
            <p style={{ color: theme.palette.common.blue }}>
              {makeRowColumn(
                rowObj['NEWS_CLICK_RATE'],
                valObj.type,
                valObj.format
              )}
            </p>
          );
        },
      },
      NEWS_INF_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('유입수')}
                  tooltipTitle={t('타입별 유입된 사용자수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        headStyle: {
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderRight: '1px solid #e5e8eb',
        },
      },
      REQ_CNT: {
        merged: true,
      },
      PAR_EPRS_CNT: {
        merged: true,
      },
      ENT_RATE: {
        merged: true,
      },
      CLICK_CNT: {
        merged: true,
      },
      CLICK_RATE: {
        merged: true,
      },
      AVG_ADVRTS_AMT: {
        merged: true,
      },
      ADVRTS_AMT: {
        merged: true,
      },
      TOT_MC_POINT: {
        merged: true,
      },
      NEWS_ACCOUNT_AMT: {
        merged: true,
      },
      ECPM: {
        merged: true,
      },
      TOT_MC_ECPM: {
        merged: true,
      },
      NEWS_ACCOUNT_ECPM: {
        merged: true,
      },
      OUT_LINK_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('아웃링크수')}
                  tooltipTitle={t('언론사 사이트로 직접 유입된수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
      },
    };
  } else {
    customized = {
      STATS_DTTM: {
        makeHead: (headsMap) => {
          return `${getHeadObj(headsMap, 'STATS_DTTM').label}`;
        },
        makeBody: (rowObj, headsMap) => {
          const statsDttm = getHeadObj(headsMap, 'STATS_DTTM');
          const { isPop } = params;
          const convertKeys = ['mfSupplyTpCode', 'pltfomTpCode'];
          const addParams = dataConverter(params, convertKeys, 'string');
          const showWindowUrl =
            '/report/mobfeed/channel?isPop=1&sDate=' +
            rowObj['STATS_DTTM'] +
            '&eDate=' +
            rowObj['STATS_DTTM'] +
            '&uri=/report/mobfeed/daily' +
            addParams;

          let resultComponent;

          resultComponent = (
            <>
              {rowObj['STATS_DTTM'] !== 'total' && parseInt(isPop) !== 1 ? (
                <>
                  <IconAreaWrap
                    text={makeRowColumn(
                      rowObj['STATS_DTTM'],
                      statsDttm.type,
                      statsDttm.format
                    )}
                    icon={rowObj['STATS_DTTM'] !== 'total' && 'faExternalLink'}
                    toolTipTitle={t('해당 날짜의 채널별 통계')}
                    onClick={(e) => handlePortalUrl(showWindowUrl)}
                  />
                </>
              ) : (
                <>
                  {makeRowColumn(
                    rowObj['STATS_DTTM'],
                    statsDttm.type,
                    statsDttm.format
                  )}
                </>
              )}
            </>
          );

          return resultComponent;
        },
      },
      NEWS_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('수집기사수')}
                  tooltipTitle={t('모비피드 뉴스제공 언론사 수집기사수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const obj = getHeadObj(headsMap, 'NEWS_CNT');
          return (
            rowObj['STATS_DTTM'] !== 'total' &&
            !rowObj['isChild'] &&
            makeRowColumn(rowObj['NEWS_CNT'], obj.type, obj.format)
          );
        },
      },
      PAGE_VIEW: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('PV')}
                  tooltipTitle={t('페이지뷰')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
      },
      NEWS_GR_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 구좌노출수')}
                  tooltipTitle={t('기사 구좌별 노출수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const valObj = getHeadObj(headsMap, 'NEWS_GR_CNT');
          return (
            <p style={{ color: theme.palette.common.blue }}>
              {makeRowColumn(rowObj['NEWS_GR_CNT'], valObj.type, valObj.format)}
            </p>
          );
        },
      },
      NEWS_TOT_EPRS_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 총노출수')}
                  tooltipTitle={t('모비피드 뉴스제공 언론사 수집 총기사수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const valObj = getHeadObj(headsMap, 'NEWS_TOT_EPRS_CNT');
          return (
            <p style={{ color: theme.palette.common.blue }}>
              {makeRowColumn(
                rowObj['NEWS_TOT_EPRS_CNT'],
                valObj.type,
                valObj.format
              )}
            </p>
          );
        },
      },

      NEWS_CLICK_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 클릭수')}
                  tooltipTitle={t('클릭된 기사수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
      },
      NEWS_CLICK_RATE: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('기사 클릭률')}
                  tooltipTitle={t('(기사클릭수/기사구좌노촐수) * 100')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        makeBody: (rowObj, headsMap) => {
          const valObj = getHeadObj(headsMap, 'NEWS_CLICK_RATE');

          return (
            <p style={{ color: theme.palette.common.blue }}>
              {makeRowColumn(
                rowObj['NEWS_CLICK_RATE'],
                valObj.type,
                valObj.format
              )}
            </p>
          );
        },
      },
      NEWS_INF_CNT: {
        makeHead: (headsMap) => {
          return {
            content: (
              <>
                <InfoTitleArea
                  title={t('유입수')}
                  tooltipTitle={t('타입별 유입된 사용자수')}
                  iconType="fainfoCircle"
                />
              </>
            ),
          };
        },
        headStyle: {
          borderRight: '1px solid #e5e8eb',
        },
        bodyStyle: {
          borderRight: '1px solid #e5e8eb',
        },
      },
      NEWS_ACCOUNT_AMT: {
        makeHead: (headsMap) => {
          return t('정산금액');
        },
      },
      NEWS_ACCOUNT_ECPM: {
        makeHead: (headsMap) => {
          return t('정산ECPM');
        },
      },
      OUT_LINK_CNT: {
        merged: true,
      },
    };
  }
  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
        />
        <FilterCollection
          label={t('뉴스제공방식')}
          name="mfSupplyTpCode"
          params={params}
          value={params.mfSupplyTpCode}
          type="select"
          list={initList.mfSupplyTpCode}
          callBack={getParam}
          labelKey="label"
          valueKey={'value'}
        />
      </NewFilterWrap>
      {parseInt(isPop) === 1 && parseInt(channel) !== 1 ? (
        <DailyStatisticsGraphPop
          params={{
            ...paramConverter(params),
          }}
          handleClickSnackbar={handleClickSnackbar}
        />
      ) : (
        <DailyStatisticsGraph
          params={{
            ...paramConverter({ ...params, order: 'STATS_DTTM', sort: 'desc' }),
          }}
          handleClickSnackbar={handleClickSnackbar}
        />
      )}
      <NewTableContainer
        dataReqPromise={mobfeeDaily}
        params={params}
        getParam={getParam}
        customized={customized}
        useSearch={false}
      />
    </>
  );
};

export default withRouter(DailyStatistics);
